import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reliabilityActions, RELIABILITY_SECTIONS } from '../../../store/reliabilityStore';
import { reportActions } from '../../../store/reportStore';
import { Translate } from 'react-localize-redux';
import { writeWarn } from '../../common/logger';
import classnames from 'classnames'
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import PropTypes from 'prop-types';

export const reliabilityCEEStatus = {
    notRequested: 'notRequested',
    inProgress: 'inProgress',
    available: 'available',
    failed: 'failed',
};

class ReliabilityCEEStatus extends React.Component {

    static propTypes = {
        onInProgress: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash || this.props.children !== nextProps.children || this.props.reliability !== nextProps.reliability;
    }

    componentDidMount() {
        const data = this.props.data;
        if (data !== undefined && data !== null && data.reportStatus === reliabilityCEEStatus.notRequested && !this.props.reliability.isRequested)
            this.props.requestFetchSection([RELIABILITY_SECTIONS.cee]);
    }

    render() {
        if (this.props.data === undefined || this.props.data === null)
            return <NoDataComponent />;

        if (this.props.reliability && this.props.reliability.error !== null) {
            return (
                <div className="error-container error-container-wide" style={{ padding: "0.7em 1em 1em" }}>
                    <Message type='warning' message={<Translate id={this.props.reliability.error} options={{ renderInnerHtml: true }} />} shadowed={true} />
                </div>)
        }

        return (
            <div>{this.renderContent(this.props.data)}</div>
        );
    }

    renderContent = (data) => {
        switch (data.reportStatus) {
            case reliabilityCEEStatus.notRequested:
                return (
                    <React.Fragment>
                        <div className="columns is-centered">
                            <div className="column is-narrow has-text-centered">
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div onClick={() => this.props.onNotRequested()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                        <Translate id="Report.Aml.Request.Submit" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            case reliabilityCEEStatus.inProgress:
                return (
                    <React.Fragment>
                        <div className="columns is-centered">
                            <div className="column is-narrow has-text-centered">
                                <span style={{ fontWeight: 600, marginBottom: "1em", display: "flex" }}><Translate id="Report.Aml.InProgressNotice" /></span>
                                <br />
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div onClick={() => this.props.onInProgress()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                        <Translate id="Report.Aml.ReloadSection" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            case reliabilityCEEStatus.available:
                return (<>
                    {this.props.children}
                </>)
            case reliabilityCEEStatus.failed:
                return <Message type='warning' message={<Translate id={"Report.Aml.FailNotice"} options={{ renderInnerHtml: true }} />} shadowed={true} />
            default:
                writeWarn('Invalid cee report status: ' + data.reportStatus);
                return null;
        }
    }
}

export default connect(
    state => ({ ...state.report, reliability: state.reliability }),
    dispatch => bindActionCreators(Object.assign({}, reportActions, reliabilityActions), dispatch)
)(ReliabilityCEEStatus);